import PlaylistPlayerAbstract from 'seshy/components/playlist/player/abstract';

export default class PlaylistPlayerCompactComponent extends PlaylistPlayerAbstract {}
